export const highImportanceMenuText = "YOE5qe";
export default {highImportanceMenuText};